export const PRIZE_DECIMAL_CHARACTER = '.';
export const PRIZE_MIN_DECIMAL_PLACES = 2;
export const PRIZE_ANIMATION_DURATION = 3;
export const PRIZE_ANIMATION_DELAY = 4;
